module.exports = __webpack_public_path__ + "1b6b39cbc22afdbd3c4427e7c3750303.svg";